"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowLatencyPlayer = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const DashJs_1 = require("../engines/DashJs");
const AssetPlayer_1 = require("./AssetPlayer");
class LowLatencyPlayer extends AssetPlayer_1.AssetPlayer {
    getPlayerEngine() {
        var _a, _b;
        const preferredFormats = this.instanceSettings.initOptions.preferredFormats;
        const format = (_b = (_a = this.instanceSettings) === null || _a === void 0 ? void 0 : _a.formats) === null || _b === void 0 ? void 0 : _b.find((f) => f.format === "DASH");
        this.mediaLocator = format === null || format === void 0 ? void 0 : format.mediaLocator;
        this.playbackFormat = format === null || format === void 0 ? void 0 : format.format;
        if ((preferredFormats === null || preferredFormats === void 0 ? void 0 : preferredFormats.includes("DASH")) ||
            (preferredFormats === null || preferredFormats === void 0 ? void 0 : preferredFormats.includes("dash"))) {
            const bitmovinEngine = this.createBitmovinEngine();
            if (bitmovinEngine) {
                return bitmovinEngine;
            }
            return new DashJs_1.DashJs(this.videoElement, this.instanceSettings);
        }
        const errMsg = `Low Latency Support for ${preferredFormats} not yet implemented`;
        throw new js_player_shared_1.InitError(errMsg, {
            type: js_player_shared_1.ErrorTypes.OPTIONS,
        });
    }
}
exports.LowLatencyPlayer = LowLatencyPlayer;
//# sourceMappingURL=LowLatencyPlayer.js.map